import {useQueries} from "@tanstack/react-query";
import ProjectService from "../../../services/project-service";
import UserService from "../../../services/user-service";
import ProductService from "../../../services/product-service";
import hardwareAttendancesService from "../../../services/hardware-attendances-service";

const UseFetchData = (project) => {
    const projectId = project?.value ?? null

    const queries = useQueries({
        queries: [
            {
                queryKey: ['projects'],
                queryFn: () => ProjectService.options().then(({data}) => data),
            },
            {
                queryKey: ['users', {project}],
                queryFn: () => UserService.getRequesters(projectId).then(({data}) => data),
                enabled: !!project
            },
            {
                queryKey: ['products', {project}],
                queryFn: () => {
                    return ProductService.getByProject(projectId).then(data => data.map(product => {
                        const label = [
                            product.pcl_id,
                            product.type && (product.pcl_id ? " - " : "") + product.type,
                            product.place && (product.pcl_id || product.type ? " - " : "") + product.place,
                        ].filter(Boolean).join('');

                        return {value: product.id, label, pcl_id: product.pcl_id, lat: product.lat, lng: product.lng, place: product.place}
                    }));
                },
                enabled: !!project
            },
            {
                queryKey: ['attendances', {project}],
                queryFn: () => hardwareAttendancesService.getByProject(projectId).then(({data}) => data),
            }
        ]
    });

    return {projects: queries[0].data, users: queries[1].data, products: queries[2].data, attendances: queries[3].data}
};

export default UseFetchData;